module.exports = __webpack_public_path__ + "img/bingo_ball-19.1727a192.png";